<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="close"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-tabs v-model="tabUser" centered>
        <v-tab
          v-for="item in itemsTabUser"
          :id="item.toLowerCase()"
          :key="item"
          class="font-size-sub"
          v-on:click="currentTabUser = item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-card-text>
        <v-container>
          <v-row v-if="currentTabUser === 'Profile'">
            <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
              <v-avatar size="128">
                <img :src="editedItem.avatar" alt="Profile" />
              </v-avatar>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="displayname"
                v-model="editedItem.displayname"
                label="Display name"
                hide-details
                :rules="[
                  rules.rulesDisplayname.required,
                  rules.rulesDisplayname.min,
                  rules.rulesDisplayname.max
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="d-flex v-middle">
                <div class="cursor-default width70px" @click="clickUserType">
                  User type
                </div>
                <v-radio-group
                  v-model="editedItem.auth_type"
                  class="m-l-10"
                  :disabled="editedIndex > -1"
                  dense
                  hide-details
                  row
                >
                  <v-radio label="Local user" value="local"></v-radio>
                  <v-radio label="Google" value="google"></v-radio>
                  <v-radio label="Azure AD" value="azure"></v-radio>
                  <v-radio label="LDAP" value="ldap"></v-radio>
                </v-radio-group>
              </div>
              <v-checkbox
                v-show="countSystemUser >= 10"
                v-model="editedItem.is_system_user"
                label="System user"
                class="m-l-80 shrink margin-checkbox"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="email"
                v-model="editedItem.email"
                :label="editedItem.auth_type === 'ldap' ? 'Username' : 'Email'"
                :rules="[rules.rulesEmail.required, rules.rulesEmail.email]"
                :disabled="editedIndex > -1"
                :readonly="readonly"
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="editedItem.auth_type === 'local' && editedIndex === -1"
            >
              <v-text-field
                id="password"
                :type="editedItem.show_password ? 'text' : 'password'"
                v-model="editedItem.password"
                label="Initial password"
                hide-details
                :append-icon="
                  editedItem.show_password ? 'mdi-eye' : 'mdi-eye-off'
                "
                :disabled="editedItem.disablePassword"
                :rules="[rules.rulesPassword.required]"
                :readonly="readonly"
                @click:append="
                  editedItem.show_password = !editedItem.show_password
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-select
                id="role"
                item-text="label"
                item-value="_id"
                v-model="editedItem.role_id"
                :items="roles"
                label="Role"
                hide-details
                :disabled="editedItem.disableEdit"
              >
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  <div :id="`select-role${roles.indexOf(data.item)}`">
                    {{ data.item.label }}
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                id="status"
                v-model="editedItem.is_active"
                :label="editedItem.is_active ? 'Active' : 'Inactive'"
                :disabled="editedItem.disableEdit"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>

          <v-row v-if="currentTabUser === 'Voice queue'">
            <v-col cols="12" sm="12" lg="12" class="d-flex">
              <div class="width100">
                <div class="font-weight-bold m-b-10">
                  <v-icon small left> fa-phone </v-icon>
                  Assigned queues
                </div>
                <draggable class="list-group" :list="voiceSkills" group="voice">
                  <div
                    v-for="(skill, index) in voiceSkills"
                    :key="`skill-voice-${index}`"
                  >
                    <v-chip
                      v-if="skill.type === 'voice' && skill.status"
                      class="ma-1"
                      outlined
                    >
                      <span class="span-priority">{{ index + 1 }}</span>
                      {{ skill.name }}
                    </v-chip>
                  </div>
                </draggable>
              </div>
              <v-icon class="m-l-10 m-r-10"> fa-exchange-alt </v-icon>
              <div class="width100">
                <div class="font-weight-bold m-b-10">Unassigned queues</div>
                <draggable
                  class="list-group dashed"
                  :list="queuesList"
                  group="voice"
                >
                  <span
                    v-for="(queue, index) in queuesList"
                    :key="`queue-voice-${index}`"
                  >
                    <v-chip
                      v-if="queue.type === 'voice' && queue.status"
                      class="ma-1"
                      outlined
                    >
                      {{ queue.name }}
                    </v-chip>
                  </span>
                </draggable>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="currentTabUser === 'Chat queue'">
            <v-col cols="12" sm="12" lg="12" class="d-flex">
              <div class="width100">
                <div class="font-weight-bold m-b-10">
                  <v-icon small left> </v-icon>
                  Assigned queues
                </div>
                <draggable class="list-group" :list="chatSkills" group="chat">
                  <div
                    v-for="(skill, index) in chatSkills"
                    :key="`skill-chat-${index}`"
                  >
                    <v-chip
                      v-if="skill.type === 'chat' && skill.status"
                      class="ma-1"
                      outlined
                    >
                      <span class="span-priority">{{ index + 1 }}</span>
                      {{ skill.name }}
                    </v-chip>
                  </div>
                </draggable>
              </div>
              <v-icon class="m-l-10 m-r-10"> fa-exchange-alt </v-icon>
              <div class="width100">
                <div class="font-weight-bold m-b-10">Unassigned queues</div>
                <draggable
                  class="list-group dashed"
                  :list="queuesList"
                  group="chat"
                >
                  <span
                    v-for="(queue, index) in queuesList"
                    :key="`queue-chat-${index}`"
                  >
                    <v-chip
                      v-if="queue.type === 'chat' && queue.status"
                      class="ma-1"
                      outlined
                    >
                      {{ queue.name }}
                    </v-chip>
                  </span>
                </draggable>
              </div>
            </v-col>

            <v-col cols="12" sm="9" lg="9">
              <v-select
                id="auto_pickup_capacity"
                v-model="editedItem.setting.auto_pickup_capacity"
                :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                label="Auto pick up capacity (0 = don't auto pick up)"
                hide-details
              >
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  <div :id="`select-auto_pickup_capacity${data.item}`">
                    {{ data.item }}
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error" class="red--text text-center">
        {{ errorMessage.text }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" text @click="close"
          >Cancel</v-btn
        >
        <v-btn id="btn-ok" class="btn-primary" text @click="save">{{
          btnSave
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import draggable from '@/plugins/vuedraggable'
// import rawDisplayer from '@/components/vuedraggable/raw-displayer.vue'
export default {
  name: 'DialogManageUserManagement',
  components: {
    draggable
    // rawDisplayer
  },
  props: {
    dialog: Boolean,
    roles: Array,
    editedIndex: Number,
    editedItem: Object,
    errorMessage: Object,
    rules: Object,
    drags: Array,
    queues: Array
  },
  data() {
    return {
      // avatar: Avatar,
      viewType: process.env.VUE_APP_TYPE,
      tabUser: null,
      currentTabUser: 'Profile',
      itemsTabUser: ['Profile'],
      voiceSkills: [],
      chatSkills: [],
      queuesList: [],
      readonly: true,
      setTimeoutReadonly: null,
      countSystemUser: 0
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New user' : 'Edit user'
    },
    btnSave() {
      return this.editedIndex === -1 ? 'Add' : 'Save'
    },
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  watch: {
    currentTabUser: {
      handler() {
        this.preventAutoFill()
      }
    },
    'editedItem.auth_type': {
      handler() {
        this.preventAutoFill()
      }
    }
  },
  created() {
    if (this.viewAll() || this.viewVoice()) {
      this.itemsTabUser.push('Voice queue')
    }
    if (this.viewAll() || this.viewChat()) {
      this.itemsTabUser.push('Chat queue')
    }
    this.voiceSkills = _.filter(this.drags, { type: 'voice' })
    this.chatSkills = _.filter(this.drags, { type: 'chat' })

    this.queuesList = JSON.parse(JSON.stringify(this.queues))

    setTimeout(() => {
      this.readonly = false
    }, 1000)
  },
  methods: {
    preventAutoFill() {
      if (this.currentTabUser === 'Profile' && !this.editedItem.email) {
        clearTimeout(this.setTimeoutReadonly)

        this.readonly = true

        this.setTimeoutReadonly = setTimeout(() => {
          this.readonly = false
        }, 1000)
      }
    },
    viewVoice() {
      return this.viewType === 'voice'
    },
    viewChat() {
      return this.viewType === 'chat'
    },
    viewAll() {
      return this.viewType === 'all'
    },
    close() {
      this.$emit('close', null)
    },
    save() {
      const skills = [...this.voiceSkills, ...this.chatSkills]
      this.$emit('save', skills)
    },
    clickUserType() {
      this.countSystemUser += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__text {
  height: 600px;
}
.border-chip {
  width: 100%;
  border: 1px solid #ebebeb;
  min-height: 50px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  height: 270px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  width: 100%;
  border-radius: 8px;
  padding: 5px !important;
  overflow-y: auto;
  &.dashed {
    border: 1px dashed rgba(0, 0, 0, 0.125);
  }
}
.list-group-item i {
  cursor: pointer;
}
.odd {
  background-color: #f9fafb !important;
}
.span-priority {
  min-width: 20px;
  min-height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #ebebeb !important;
  border-radius: 50%;
  padding: 0 3px;
  font-size: 12px;
  font-weight: 700;
  margin-right: 5px;
}
.queue-unselect {
  position: absolute;
  right: 5px;
}

.v-input--selection-controls {
  margin: 0;
}

.width130px {
  width: 130px;
}
</style>
